import { h, Component } from 'preact';
import 'preact-material-components/Drawer/style.css';
import 'preact-material-components/Button/style.css';
import TopAppBar from 'preact-material-components/TopAppBar';
import 'preact-material-components/TopAppBar/style.css';
import Chips from 'preact-material-components/Chips';
import 'preact-material-components/Chips/style.css';

import LinkChip from '../LinkChip';
import Image from '../Image';
import style from './style';

class ChipsList extends Component {
	render() {
		return (
			<div>
				<Chips>
					<LinkChip route="/" label="RSVP" />
					<LinkChip route="/details" label="Details" />
					<LinkChip route="/story" label="Our Story" />
					<LinkChip route="/wedding-party" label="Wedding Party" />
					<LinkChip route="/gifts" label="Gifts" />
					<LinkChip route="/travel" label="Travel" />
				</Chips>
			</div>
		);
	}
}

class AppBar extends Component {
	render() {
		return (
			<div>
				<TopAppBar fixed flat class={style.appBar}>
					<TopAppBar.Row class={style.appBarRow}>

						<TopAppBar.Section>
							<ChipsList />
						</TopAppBar.Section>

						<TopAppBar.Section align-end class={style.homeLink}>
							<a href="/">
								<Image
									filename="curved-branch"
									alt="ben.marrying.kim homepage"
								/>
							</a>
						</TopAppBar.Section>

					</TopAppBar.Row>
				</TopAppBar>
			</div>
		);
	}
}

export default class Header extends Component {
	render() {
		return (
			<div class={style.pageHeader}>
				<AppBar />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/Header/index.js